<template>
  <div class="col-3 d-flex">
    <div class="card mb-4" v-if="configuration.data.name !== 'Platzhalter'">
      <div class="card-header font-weight-bold text-center">{{ configuration.data.name }}</div>
      <div class="card-body d-flex flex-column shadow-sm">
        <div class="d-flex justify-content-center mb-2">
          <div :class="`badge ${statusClass}`" v-show="status !== ''">{{ status }}</div>
        </div>
        <div class="mb-3 position-relative d-flex align-items-center justify-content-center">
          <img :src="configuration.data.bild" alt="image" class="w-100" v-if="configuration.data.bild !== ''">
          <img src="https://via.placeholder.com/458x380/fff/000?text=Kein Bild" alt="image" class="w-100" v-else>
        </div>
        <div class="d-flex justify-content-center">
          <router-link
            :to="{ name: 'EditConfigurationView', params: { configurationId: configuration.id }, query: { deviceName: encodeURI(deviceName) } }"
            class="btn btn-outline-primary mr-2" title="Bearbeiten">
            <fa-icon fixed-width :icon="['fas', 'edit']" />
          </router-link>
          <!-- <button type="button" class="btn btn-outline-secondary mr-2" v-on:click="$emit('dupliziereKonfiguration', { id: configuration.id })" title="Duplizieren">
            <fa-icon fixed-width :icon="['fas', 'clone']" />
          </button> -->
          <b-dropdown variant="outline-secondary" class="mr-2">
            <template #button-content>
              <fa-icon fixed-width :icon="['fad', 'spinner-third']" :spin="true" v-if="generatingFile === true" />
              <fa-icon fixed-width :icon="['fas', 'file-download']" v-else />
            </template>
            <b-dropdown-item v-on:click="generateDeluxeImportFile(configuration.id)">Deluxe
              Import-Datei</b-dropdown-item>
            <b-dropdown-item
              v-on:click="generateComponentsFile(configuration.id)">Komponentenübersicht</b-dropdown-item>
          </b-dropdown>
          <button type="button" class="btn btn-outline-danger"
            v-on:click="$emit('loescheKonfiguration', { id: configuration.id, name: configuration.data.name })"
            title="Löschen">
            <fa-icon fixed-width :icon="['fas', 'trash']" />
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-4 flex-grow-1 align-items-center justify-content-center" v-else>
      <button type="button" class="btn btn-outline-danger"
        v-on:click="$emit('loescheKonfiguration', { id: configuration.id, name: configuration.data.name })"
        title="Löschen">
        <fa-icon fixed-width :icon="['fas', 'trash']" />
      </button>
    </div>
  </div>
</template>

<script>
import { storage, functions } from "../plugins/firebase"
import { httpsCallable } from "firebase/functions"
import { getDownloadURL, ref as storageRef } from "firebase/storage"

export default {
  name: 'ConfigurationCardComponent',
  props: {
    configuration: Object
  },
  computed: {
    deviceName: function () {
      return decodeURI(this.$route.query.deviceName)
    },
    deviceId: function () {
      return decodeURI(this.$route.params.deviceId)
    },
    status: function () {
      const selectedStatus = this.configuration.data.selectedStatus
      if (selectedStatus === 'neu') {
        return 'Neu'
      } else if (selectedStatus === 'wartung') {
        return 'In Wartung'
      } else if (selectedStatus === 'in-kuerze-verfuegbar') {
        return 'In Kürze verfügbar'
      } else if (selectedStatus === 'ausblenden') {
        return 'Ausgeblendet'
      } else {
        return ''
      }
    },
    statusClass: function () {
      const selectedStatus = this.configuration.data.selectedStatus
      if (selectedStatus === 'neu') {
        return 'badge-danger'
      } else if (selectedStatus === 'wartung') {
        return 'badge-warning'
      } else if (selectedStatus === 'in-kuerze-verfuegbar') {
        return 'badge-warning'
      } else if (selectedStatus === 'ausblenden') {
        return 'badge-secondary'
      } else {
        return ''
      }
    }
  },
  methods: {
    generateComponentsFile: async function (configurationId) {
      this.generatingFile = true
      const generateComponentsFile = httpsCallable(functions, 'componentsFile')
      const filePath = await generateComponentsFile({ configurationId: configurationId }).then(result => result.data)
      const downloadURL = await this.getDownloadURLFromPath(filePath).then(downloadURL => downloadURL)
      this.$emit('showDownloadModal', downloadURL)
      this.generatingFile = false
    },
    generateDeluxeImportFile: async function (configurationId) {
      this.generatingFile = true
      const generateDeluxeImportFile = httpsCallable(functions, 'deluxeImportFile')
      const filePath = await generateDeluxeImportFile({ configurationId: configurationId }).then(result => result.data)
      const downloadURL = await this.getDownloadURLFromPath(filePath).then(downloadURL => downloadURL)
      this.$emit('showDownloadModal', downloadURL)
      this.generatingFile = false
    },
    getDownloadURLFromPath: function (filePath) {
      return getDownloadURL(storageRef(storage, filePath))
    }
  },
  data() {
    return {
      generatingFile: false
    }
  }
}
</script>

<style scoped>
.badge-danger {
  color: white !important;
}
</style>